/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WindowSize } from '../WindowSize.js';
import { useNavigate } from 'react-router-dom';
import { GetUrl, CTicksToDateString, formatNumber } from '../Utility.js';

import Title from './Title.js';
import DetailModalType1 from './DetailModalType1.js'
import WriteModalType from './WriteModalType.js'

function Guide() {
  const state=useSelector((state)=>state);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 

    const RequestGuideList = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            }
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminGetGuideList', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    dispatch({type:'UpdateGuideArray', Log:data.data_array});  
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                var startTime = CTicksToDateString(data.start_time);
                var endTime = CTicksToDateString(data.end_time);

                var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                alert(message);  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };

    function GetGuideClick(index)
    {
        if(state.GuideArray === undefined || state.GuideArray.length <= index)
        {
            return false;
        }

        return true;
    }

    function GuideClick(index)
    {
        if(state.GuideArray === undefined || state.GuideArray.length <= index)
        {
            return;
        }

        dispatch({type:'UpdateDetailModalType1', View:true, Type:1, No:state.GuideArray[index].no});
    }

    function GetGuideNo(index)
    {
        if(state.GuideArray === undefined || state.GuideArray.length <= index)
        {
            return "";
        }

        return index + 1;
    }

    function GetGuideTitle(index)
    {
        if(state.GuideArray === undefined || state.GuideArray.length <= index)
        {
            return "";
        }

        return state.GuideArray[index].title;
    }

    function GetGuideRegisterTime(index)
    {
        if(state.GuideArray === undefined || state.GuideArray.length <= index)
        {
            return "";
        }

        return CTicksToDateString(state.GuideArray[index].create_at_time);
    }
 
    const RequestDelete = async (index) => 
    {
        if(window.confirm(state.GuideArray[index].title + " 정말로 삭제 하시겠습니까?")) {
            try
            {
                if(state.Request === 1)
                {
                    return;
                }
    
                var secretkey = sessionStorage.getItem("secret_key");
                if(secretkey === null)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                    return;    
                }
                
                dispatch({type:'Request'});
                const response = await fetch(GetUrl() + 'Admin/AdminDeleteGuide', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ secret_key : secretkey, no : state.GuideArray[index].no}),
                });
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.result === 0)
                    {
                    }
                    else if(data.result === 14 ||
                            data.result === 16)
                    {
                        alert('존재 하지 않는 티켓 입니다');  
                    }
                    else if(data.result === 15)
                    {
                        alert('이미 사용한 티켓 입니다');  
                    }
                    else if(data.result === 3 ||
                            data.result === 1)
                    {
                        alert('유저 정보 만료(다시 로그인 해주세요)');  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                    else if(data.result === 21) // 점검 중
                    {
                        var startTime = CTicksToDateString(data.start_time);
                        var endTime = CTicksToDateString(data.end_time);
        
                        var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                        alert(message);  
                        navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                    }
                } 
                else
                {
                    alert('Network Fail');
                }
    
                dispatch({type:'Response'});

                RequestGuideList();
            }
            catch(error)
            {
                alert('Network Fail');
                dispatch({type:'Response'});
                console.error(error);
            }
        }
    }

  function WriteModal()
  {
    if(state.GuideArray.length === 10)
    {
        alert('10개 이상 등록 할 수 없습니다다. 삭제 후 등록 해주세요');
        return;
    }

    dispatch({type:'UpdateWriteModal', View:true, Type:1});
  }

  const closeDetailModalType1 = () => {
    dispatch({type:'UpdateDetailModalType1', View:false, Type:0, No:0});
  }

  const closeWriteModalType = (refresh) => {
    dispatch({type:'UpdateWriteModal', View:false, Type:0});
    if(refresh === true)
    {
        RequestGuideList();
        dispatch({type:'RefreshGuide', Refresh:false});
    }
  }

    if(state.GuideFirstRender === false)
    {
        dispatch({type:'GuideFirstRender'});
        RequestGuideList();
    }  

  return (
    <div id='Player_Range'>
        <Title DisplayType="7"></Title>
        <div className='search-box'>
            <div className='search_button' onClick={() => WriteModal()}>글쓰기</div>
        </div>
        <div className='guide-box'>
            <div className='guide-box-table'>
                <tr>
                    <th style={{width:"5%"}}>넘버</th>
                    <th style={{width:"10%"}}>제목</th>
                    <th style={{width:"10%"}}>작성일</th>
                    <th style={{width:"10%"}}>삭제</th>
                </tr>
                {Array.from({length:10}).map((_, index)=>(
                <tr>
                    <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default', width:"200px", textAlign:"center"}}>{GetGuideNo(index)}</td>
                    <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default', width:"600px", textAlign:"center"}}>{GetGuideTitle(index)}</td>
                    <td onClick={() => GetGuideClick(index) === true && GuideClick(index)} style={{cursor: GetGuideClick(index) === true ? 'pointer' : 'default', width:"300px", textAlign:"center"}}>{GetGuideRegisterTime(index)}</td>
                    <td>
                        {GetGuideClick(index) === true &&
                          <div className='guide-button-group'>
                            <div className='guide-delete-button' onClick={() => RequestDelete(index)}>삭제</div>
                          </div>}
                    </td>
                </tr>
                ))}
            </div>
        </div>
        <DetailModalType1 isOpen={state.detail_modal_type1_open} Type={state.detail_modal_type1_type} No={state.detail_modal_type1_no} onClose={closeDetailModalType1} ></DetailModalType1>
        <WriteModalType isOpen={state.write_modal_open} onClose={closeWriteModalType}></WriteModalType>
    </div>
  );
}

export default Guide;